export const INLINE_COLLECTION_FIELD_IDS = new Set([
  'collection_scope',
  'dataset_scope',
  'collections',
  'datasets',
]);
